import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer } from "@fleet/ui";
import { TrashView } from "@/features/trash/components/trash-view";

function TrashRoutePage() {
  // No auth gate: trash is local-first and operates on the active account's
  // SQLite; without an org it simply shows the empty state.
  return (
    <PageContainer maxWidth="3xl">
      <TrashView />
    </PageContainer>
  );
}

export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: TrashRoutePage,
});
